<template>
    <popup class="popup-time-range" v-model="isActive">
        <!-- 内容区域 -->
        <div class="half-pop-content" :style="{'height': windowHeight}">
            <!-- 肖凯，内科专家，关闭按钮 -->
            <div class="time-range-title flex-row flex-align-center">
                <div class="flex-1" @click.stop=""><slot name="title"></slot></div>
                <span class="right-fork"></span>
            </div>
            <!-- 时段列表 -->
            <scroll class="half-scroll">
                <slot name="list"></slot>
            </scroll>
        </div>
    </popup>
</template>
<script>
export default {
        props: {
            dataList: Array,
            maxShowCount: {
                type: Number,
                default: function() {
                    return 5;
                }
            },
            lineHeight: {
                type: Number,
                default: function() {
                    return 2.55;
                }
            },
            value: Boolean,
        },
        data() {
            return {
                isActive: this.value,
            }
        },
        computed:{
            windowHeight() {
                const maxHeight = this.lineHeight * this.maxShowCount
                const titleHeight = 2.25
                let height = titleHeight + (this.lineHeight * this.dataList.length)
                if(height > maxHeight){
                    height = maxHeight
                }
                return height + "rem"
            },
        },
        mounted() {

        },
        methods: {

        },
        watch: {
            isActive(val){
                this.$emit('input', val)
            },
            value(val){
                this.isActive = val;
            }
        }
}
</script>
<style lang="scss" scoped>
    @import '../../static/sass/_variable.scss';
    .half-pop-content {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
    }
    .time-range-title {
        background-color: #f8f8f8;
        height: 2.25rem;
        line-height: 2.25rem;
        padding-left: 0.75rem;
        padding-right: 0.75rem;
    }
    .half-scroll {
        position: absolute;
        top: 2.25rem;
        bottom: 0;
        overflow-y: auto;
        padding: 0;
    }
    .popup-time-range {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        overflow-y: auto;
        text-align: left;
        color: #444;
        background-color: rgba(0,0,0,0.7);
        z-index: 4;
        list-style: none;
    }
    .right-fork{
        width: 0.7rem;
        height: 0.675rem;
        margin-left: 0.75rem;
        background: url("../../static/img/pop-btn.png") no-repeat;
        background-size: contain;
    }
</style>


// WEBPACK FOOTER //
// HalfWindow.vue?68c0dad2